// Portal i18n — strings in Hebrew, English, Arabic
export const LANGS = ['he', 'en', 'ar'];

export const i18n = {
  he: {
    dir: 'rtl',
    loginTitle: 'פורטל לקוחות',
    loginSubtitle: 'צפייה בנתוני הפנסיה שלך',
    emailLabel: 'כתובת מייל',
    emailPlaceholder: 'example@email.com',
    passwordLabel: 'סיסמה',
    passwordPlaceholder: '••••••••',
    loginBtn: 'כניסה',
    loggingIn: 'מתחבר...',
    registerTitle: 'הגדרת סיסמה לפורטל',
    registerSubtitle: (name) => `שלום ${name}, הגדר סיסמה לכניסה לפורטל`,
    chooseEmail: 'בחר כתובת מייל לכניסה',
    choosePassword: 'בחר סיסמה (לפחות 6 תווים)',
    confirmPassword: 'אימות סיסמה',
    registerBtn: 'הצטרף לפורטל',
    registering: 'מייצר חשבון...',
    passwordMismatch: 'הסיסמאות אינן תואמות',
    passwordTooShort: 'הסיסמה חייבת לכלול לפחות 6 תווים',
    tokenExpired: 'הקישור פג תוקף או אינו תקין. פנה ליועץ שלך.',
    loginError: 'שגיאה בכניסה. בדוק מייל וסיסמה.',
    registerError: 'שגיאה ביצירת החשבון.',
    emailAlreadyUsed: 'כתובת המייל הזו כבר רשומה. נסה להתחבר דרך עמוד הכניסה.',
    logout: 'התנתק',
    loading: 'טוען...',
    loadError: 'שגיאה בטעינת הנתונים. נסה לרענן.',
    welcome: (name) => `שלום, ${name}`,
    lastUpdate: 'עדכון אחרון',
    noData: 'אין נתוני אחזקות זמינים כרגע. פנה ליועץ שלך.',
    linkExpired: 'הקישור לא תקין',
    alreadyRegistered: 'כבר רשום? ',
    loginLink: 'כניסה',
    backToLogin: 'חזרה לכניסה',
    forgotPassword: 'שכחתי סיסמה',
    forgotTitle: 'איפוס סיסמה',
    forgotSubtitle: 'הזן את כתובת המייל שלך ונשלח לך קישור לאיפוס',
    sendResetBtn: 'שלח קישור',
    sendingReset: 'שולח...',
    resetSent: 'הקישור נשלח!',
    resetSentMsg: (email) => `שלחנו קישור לאיפוס סיסמה אל ${email}. בדוק את תיבת הדואר.`,
    newPasswordTitle: 'הגדר סיסמה חדשה',
    newPasswordLabel: 'סיסמה חדשה',
    confirmNewPassword: 'אימות סיסמה חדשה',
    setPasswordBtn: 'שמור סיסמה',
    settingPassword: 'שומר...',
    passwordChanged: 'הסיסמה עודכנה! מתחבר...',
  },
  en: {
    dir: 'ltr',
    loginTitle: 'Client Portal',
    loginSubtitle: 'View your pension portfolio',
    emailLabel: 'Email address',
    emailPlaceholder: 'example@email.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    registerTitle: 'Set Portal Password',
    registerSubtitle: (name) => `Hello ${name}, please set a password to access the portal`,
    chooseEmail: 'Choose your email address',
    choosePassword: 'Choose a password (at least 6 characters)',
    confirmPassword: 'Confirm password',
    registerBtn: 'Join Portal',
    registering: 'Creating account...',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    tokenExpired: 'This link has expired or is invalid. Please contact your advisor.',
    loginError: 'Login failed. Check your email and password.',
    registerError: 'Account creation failed.',
    emailAlreadyUsed: 'This email is already registered. Try signing in.',
    logout: 'Sign Out',
    loading: 'Loading...',
    loadError: 'Failed to load data. Please refresh.',
    welcome: (name) => `Hello, ${name}`,
    lastUpdate: 'Last update',
    noData: 'No holdings data available. Please contact your advisor.',
    linkExpired: 'Invalid link',
    alreadyRegistered: 'Already registered? ',
    loginLink: 'Sign in',
    backToLogin: 'Back to sign in',
    forgotPassword: 'Forgot password',
    forgotTitle: 'Reset Password',
    forgotSubtitle: 'Enter your email and we\'ll send you a reset link',
    sendResetBtn: 'Send link',
    sendingReset: 'Sending...',
    resetSent: 'Link sent!',
    resetSentMsg: (email) => `We sent a password reset link to ${email}. Check your inbox.`,
    newPasswordTitle: 'Set New Password',
    newPasswordLabel: 'New password',
    confirmNewPassword: 'Confirm new password',
    setPasswordBtn: 'Save password',
    settingPassword: 'Saving...',
    passwordChanged: 'Password updated! Signing in...',
  },
  ar: {
    dir: 'rtl',
    loginTitle: 'بوابة العملاء',
    loginSubtitle: 'عرض بيانات تقاعدك',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'example@email.com',
    passwordLabel: 'كلمة المرور',
    passwordPlaceholder: '••••••••',
    loginBtn: 'تسجيل الدخول',
    loggingIn: 'جارٍ الدخول...',
    registerTitle: 'تعيين كلمة مرور البوابة',
    registerSubtitle: (name) => `مرحباً ${name}، يرجى تعيين كلمة مرور للوصول إلى البوابة`,
    chooseEmail: 'اختر عنوان بريدك الإلكتروني',
    choosePassword: 'اختر كلمة مرور (6 أحرف على الأقل)',
    confirmPassword: 'تأكيد كلمة المرور',
    registerBtn: 'انضم إلى البوابة',
    registering: 'جارٍ إنشاء الحساب...',
    passwordMismatch: 'كلمتا المرور غير متطابقتين',
    passwordTooShort: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    tokenExpired: 'انتهت صلاحية هذا الرابط. يرجى التواصل مع مستشارك.',
    loginError: 'فشل تسجيل الدخول. تحقق من البريد الإلكتروني وكلمة المرور.',
    registerError: 'فشل إنشاء الحساب.',
    emailAlreadyUsed: 'البريد الإلكتروني مسجل مسبقاً. حاول تسجيل الدخول.',
    logout: 'تسجيل الخروج',
    loading: 'جارٍ التحميل...',
    loadError: 'فشل تحميل البيانات. يرجى التحديث.',
    welcome: (name) => `مرحباً، ${name}`,
    lastUpdate: 'آخر تحديث',
    noData: 'لا توجد بيانات متاحة. يرجى التواصل مع مستشارك.',
    linkExpired: 'رابط غير صالح',
    alreadyRegistered: 'مسجل مسبقاً؟ ',
    loginLink: 'تسجيل الدخول',
    backToLogin: 'العودة إلى تسجيل الدخول',
    forgotPassword: 'نسيت كلمة المرور',
    forgotTitle: 'إعادة تعيين كلمة المرور',
    forgotSubtitle: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين',
    sendResetBtn: 'إرسال الرابط',
    sendingReset: 'جارٍ الإرسال...',
    resetSent: 'تم إرسال الرابط!',
    resetSentMsg: (email) => `أرسلنا رابط إعادة تعيين كلمة المرور إلى ${email}. تحقق من بريدك.`,
    newPasswordTitle: 'تعيين كلمة مرور جديدة',
    newPasswordLabel: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    setPasswordBtn: 'حفظ كلمة المرور',
    settingPassword: 'جارٍ الحفظ...',
    passwordChanged: 'تم تحديث كلمة المرور! جارٍ تسجيل الدخول...',
  },
};

export const LANG_LABELS = { he: 'עברית', en: 'English', ar: 'عربي' };

export function detectLang() {
  const saved = localStorage.getItem('portal_lang');
  if (saved && i18n[saved]) return saved;
  const browser = navigator.language?.slice(0, 2);
  if (browser === 'ar') return 'ar';
  if (browser === 'en') return 'en';
  return 'he';
}
